<template>
  <div class="mb-6 mt-3 md:mt-0 relative">
    <div>
      <div>
        <div class="text-xl text-[#09518C]">Profile</div>
        <small @click="onToggle" class="text-[#8DC63F] cursor-pointer"
          >Update Password</small
        >
      </div>
      <div class="mt-6 flex flex-col items-center text-center">
        <div
          class="h-16 w-16 bg-black flex items-center justify-center text-white rounded-full md:h-24 md:w-24"
        >
          {{ $store.getters?.getLoggedInUserFirstAndLast }}
        </div>
        <div class="flex flex-col p-4 mx-4">
          <p
            class="text-sm md:text-md lg:text-lg xl:text-lg font-bold text-[#09518C]"
          >
            {{ $store.state?.getLoggedInUser?.name }}
          </p>
          <p class="text-gray-400">
            {{ $store.state?.getLoggedInUser?.code }}
          </p>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <div class="text-sm font-semibold text-center mb-1 text-[#09518C]">
        Your Relationship Manager
      </div>
      <div
        class="flex justify-center items-center shadow border md:w-1/3 md:mx-auto lg:w-1/2"
      >
        <div
          class="h-12 w-12 bg-[#8DC63F] flex items-center px-2 justify-center text-white rounded-full"
        >
          {{ $store.getters.getRMUFirstAndLast }}
        </div>
        <div class="flex flex-col p-2 ml-2">
          <p class="text-sm text-gray-400">
            {{ $store.state?.getLoggedInUser?.rmu_name }}
          </p>
          <p class="text-sm text-gray-400">
            {{ $store.state?.getLoggedInUser?.rmu_mobile }}
          </p>
          <a target="_blank" class="text-sm text-[#8DC63F]">
            {{ $store.state?.getLoggedInUser?.rmu_email }}
          </a>
        </div>
      </div>
    </div>

    <div>
      <div>
        <div class="text-sm font-semibold text-center my-4 text-[#09518C]">
          Employer Contact Person
        </div>
        <button
          @click="onCreateToggle"
          v-if="currentUser?.contact_status === 'admin'"
          class="bg-[#8DC63F] text-white py-2 px-4 rounded-lg"
        >
          <font-awesome-icon icon="fa-plus" /> ADD
        </button>
      </div>
      <div class="mt-2 grid-cols-3-custom md:grid gap-4 md:grid-cols-2">
        <div
          v-for="contact in contacts"
          :key="contact.id"
          class="py-4 px-2 w-full mb-3 bg-white shadow-md border md:mb-0"
        >
          <div class="flex flex-col justify-center items-center text-center">
            <div class="rounded-full bg-green-200 h-10 w-10 text-center pt-2">
              {{
                contact?.name
                  .match(/(^\S\S?|\b\S)?/g)
                  .join("")
                  .match(/(^\S|\S$)?/g)
                  .join("")
                  .toUpperCase()
              }}
            </div>
            <div class="flex leading-loose flex-col mx-4">
              <p class="font-bold">
                {{ contact?.name }}
              </p>
              <p class="text-gray-600">
                {{ contact?.phone_number }}
              </p>
              <a class="text-[#8DC63F] text-sm">
                {{ contact?.email }}
              </a>
              <div
                class="text-center"
                v-if="
                  $store.state.getLoggedInUser?.contact_code !==
                  contact?.contact_code
                "
              >
                <a
                  class="text-right cursor-pointer hover:text-[#8DC63F]"
                  @click="onAllowLoginToggle(contact)"
                  v-if="currentUser?.contact_status === 'admin'"
                  >Allow Login?</a
                >
              </div>
            </div>
          </div>
          <div class="text-sm" v-if="currentUser?.contact_status === 'admin'">
            <span
              @click="onDeleteModal(contact)"
              class="my-2 h-6 w-6 bg-fail-light flex items-center text-fail justify-center p-2 rounded-full cursor-pointer hover:text-[#8DC63F]"
              v-if="
                $store.state.getLoggedInUser?.contact_code !==
                contact?.contact_code
              "
            >
              <font-awesome-icon icon="fa-trash" />
            </span>
          </div>
        </div>
        <div v-if="loading === true"></div>
        <LoadingSpinner v-if="loading === true" />
      </div>
    </div>

    <ModalPassword :isModalVisible="isModalVisible" :onToggle="onToggle" />

    <ModalCreate
      :isCreateModalVisible="isCreateModalVisible"
      :onCreateToggle="onCreateToggle"
      :caseLoading="caseLoading"
    />

    <DeleteModal
      :isDeleteModalVisible="isDeleteModalVisible"
      :onDeleteModal="onDeleteModal"
    />

    <AllowLoginModal
      :getContactDeleteDetails="getContactDeleteDetails"
      :isAllowLoginModalVisible="isAllowLoginModalVisible"
      :loginStatusErrorMessage="loginStatusErrorMessage"
      :loginStatusLoading="loginStatusLoading"
      :loginStatusMessage="loginStatusMessage"
      :onAllowLoginToggle="onAllowLoginToggle"
      :toggleLoginStatus="toggleLoginStatus"
    />
  </div>
</template>

<script>
import { ref, computed } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { toolkitAxios } from "@/env";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ModalPassword from "@/components/modals/ModalPassword.vue";
import ModalCreate from "@/components/modals/ModalCreate.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import AllowLoginModal from "@/components/modals/AllowLogin.vue";
export default {
  components: {
    LoadingSpinner,
    ModalPassword,
    ModalCreate,
    DeleteModal,
    AllowLoginModal,
  },
  setup() {
    const isOpen = ref(false);
    const isCreateOpen = ref(false);
    const isDeleteOpen = ref(false);
    const isAllowLogin = ref(false);
    const contacts = ref([]);
    const currentUser = ref("");
    const store = useStore();
    const interactionCategory = ref("");
    const interactionSubCategory = ref("");
    const type = ref(2);
    const loading = ref(false);
    const caseLoading = ref(false);
    const accountCreationError = ref("");
    const caseCreationSuccessMessage = ref("");
    const loginStatusLoading = ref(false);
    const loginStatusMessage = ref("");
    const loginStatusErrorMessage = ref("");
    const createCaseError = ref("");
    const getContactDeleteDetails = ref("");

    const isModalVisible = computed(() => isOpen.value);
    const isCreateModalVisible = computed(() => isCreateOpen.value);
    const isDeleteModalVisible = computed(() => isDeleteOpen.value);
    const isAllowLoginModalVisible = computed(() => isAllowLogin.value);

    const onToggle = () => {
      isOpen.value = !isOpen.value;
    };

    const onCreateToggle = () => {
      caseCreationSuccessMessage.value = "";
      isCreateOpen.value = !isCreateOpen.value;
    };

    const onAllowLoginToggle = (contact) => {
      getContactDeleteDetails.value = contact;
      isAllowLogin.value = !isAllowLogin.value;
      loginStatusMessage.value = "";
      loginStatusErrorMessage.value = "";
    };

    const onDeleteModal = (contact) => {
      isDeleteOpen.value = !isDeleteOpen.value;
      caseCreationSuccessMessage.value = "";
      createCaseError.value = "";

      store.dispatch("getCurrentContact", contact);
    };

    const getRelationshipManagers = async () => {
      loading.value = true;

      const response = await toolkitAxios.post(
        "employer/relationship-managers"
      );
      contacts.value = response.data.data;

      const check = contacts.value.filter(
        (user) => store.state.getLoggedInUser.contact_code == user.contact_code
      );

      currentUser.value = check[0];

      loading.value = false;
    };

    const toggleLoginStatus = async (contact) => {
      loginStatusLoading.value = true;

      let status = "false";
      if (contact.allow_login === "0") {
        status = "true";
      }

      await toolkitAxios
        .post("employer/changeloginstatus", {
          contact_id: contact.contact_code,
          status: status,
        })
        .then(() => {
          loginStatusMessage.value = `Login Status has been changed to ${status} for ${contact.name}`;
          getRelationshipManagers();
        })
        .catch(() => {
          loginStatusErrorMessage.value = `Error in changing login status, please try again later`;
        })
        .finally(() => {
          loginStatusLoading.value = false;
        });
    };

    onMounted(() => {
      getRelationshipManagers();
    });

    return {
      isOpen,
      isModalVisible,
      onToggle,
      isCreateModalVisible,
      isCreateOpen,
      onCreateToggle,
      isDeleteModalVisible,
      isDeleteOpen,
      onDeleteModal,
      getRelationshipManagers,
      contacts,
      currentUser,
      type,
      loading,
      interactionCategory,
      interactionSubCategory,
      caseLoading,
      accountCreationError,
      caseCreationSuccessMessage,
      loginStatusLoading,
      toggleLoginStatus,
      loginStatusMessage,
      isAllowLogin,
      isAllowLoginModalVisible,
      onAllowLoginToggle,
      createCaseError,
      getContactDeleteDetails,
      loginStatusErrorMessage,
    };
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .grid-cols-3-custom {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>

<style scoped>
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms ease-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
